import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionNeBox';
import {
  contentModalDep2ViewStore,
  errorModalViewStore,
  loadingModalViewStore,
} from 'src/store/modal';
import { rentMDataStore } from 'src/store/housingfunds/rentm';
import { fetchUpdateHouseRentM } from 'src/fetch/stepC/houseRentM';
import { fetchSurveyUpdate } from 'src/fetch/stepC/houseSaving';
import { getMemberInfo } from 'src/utils/common';

interface Props {
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: '0',
        nextIdx: '1',
        status: 'this',
        passed: 'N',
        confirm: '',
        confirmSet: {
          Y: { nextSeq: '1', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question: '근로소득이 있습니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">일용근로자는 '아니오' 선택</div>,
              },
            ],
          },
        },
      },
      {
        idx: '1',
        status: 'ready',
        passed: 'N',
        confirm: '',
        confirmSet: {
          Y: { nextSeq: '2', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question: '총급여액이 8천만원 이하입니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '2',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: '4', pass: 'Y' },
          N: { nextSeq: '3', pass: 'Y' },
        },
        set: {
          question: '과세기간 종료일(12.31.) 현재 세대주인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '3',
        status: 'ready',
        passed: '',
        confirmSet: {
          Y: { nextSeq: 'end', pass: 'N' },
          N: { nextSeq: '4', pass: 'Y' },
        },
        set: {
          question: '세대주가 ＂주택자금공제 등*”을 받았나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: (
                  <div className="_text">
                    * 주택임차차입금 원리금상환액공제 / 장기주택저당차입금 이자상환액 공제 /
                    주택마련저축공제
                  </div>
                ),
              },
            ],
          },
        },
      },
      {
        idx: '4',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: '5', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question: '과세기간 종료일(12.31.) 현재 세대주와 세대원 전체가 주택을 소유하지 않았나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '5',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: '6', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question:
            '임차한 주택이 국민주택규모의 주택 또는 기준시가 4억원 이하의 주택(주거용오피스텔, 고시원포함)에 해당하나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '6',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: '7', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question:
            '임대차 계약서 상 계약자가 공제받을 근로자 본인 또는 기본공제대상자에 해당하는 부양가족 인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '7',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: '8', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question: '임차 건물에 전입신고를 하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: '8',
        status: 'ready',
        passed: 'N',
        confirmSet: {
          Y: { nextSeq: 'end', pass: 'Y' },
          N: { nextSeq: 'end', pass: 'N' },
        },
        set: {
          question: '근로자 본인이 월세를 지출하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '주택공제를 받을 수 있습니다.',
        status: 'yes',
        desc: {
          style: {},
          data: [
            {
              // text: (
              //   <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              // ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);
  const userInfoData: any = getMemberInfo();

  const rentMList = rentMDataStore((state: any) => state.result).data || [];
  const bindStoreParam = rentMDataStore((state: any) => state.param);
  const bindStoreBindParam = rentMDataStore((state: any) => state.bindParam);

  const confirmEvent = async () => {
    // for (const item of rentMList) {
    //   const param = {
    //     ...item,
    //     acct_year: userInfoData.acct_year,
    //     co_cd: userInfoData.co_cd,
    //     co_id: userInfoData.co_id,
    //     question_status: 'Y',
    //   };
    //   await fetchUpdateHouseRentM(param, queryClient, errorModalState, loadingState, () => {});
    // }
    const answerStatus = awsState.set.set.status === 'no' ? 'X' : 'Y';
    for (const item of rentMList) {
      const param = {
        // ...item,
        in_data_seqid: item.in_data_seqid,
        house_type: 'rentm',
        acct_year: userInfoData.acct_year,
        co_cd: userInfoData.co_cd,
        co_id: userInfoData.co_id,
        question_status: answerStatus,
      };
      await fetchSurveyUpdate(param, queryClient, errorModalState, loadingState, () => {});
    }
    const initialSeq = bindStoreParam.initialSeq || 0;
    bindStoreBindParam({ initialSeq: initialSeq + 1 });
    setContentModalDep2State({ active: '', content: null });
  };

  useEffect(() => {
    const queEndStatus = queState.set.filter(
      (item: any) => item.status !== 'end' && item.status !== 'cancle'
    );
    const quePassed = queState.set.filter((que: any) => que.passed === 'N');
    console.log('queEndStatus:::::', queState.set, queEndStatus);

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      if (quePassed.length > 0) {
        awsState.set.set.title = '주택공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '주택공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  return (
    <div className="_spouse_question_div">
      <div className="que_box">
        <QuestionBox
          queSet={queSet}
          queState={queState}
          setQueState={setQueState}
          awsState={awsState}
          setAwsState={setAwsState}
        />
      </div>
      {awsState.set.status === 'end' ? (
        <div className="_confirm_btn_div">
          <DefaultButton
            text="확인"
            clickEvent={e => confirmEvent()}
            styleDef={{ fontSize: '13px', width: '210px', height: '38px' }}
            type="type5"
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Spouse;
